/**
 * Appel du roi (tarot à 5 joueurs) — encodage protocole legacy Java.
 *
 * Roi : appelee = index de couleur (0=Cœur … 3=Trèfle)
 * Dame (si 4 rois en main) : appelee = 128 + index de couleur
 */

import type { CardNumber } from '../types/game';
import type { AppelData } from './gameActions';

export const KING_CARDS: CardNumber[] = [14, 28, 42, 56];

/** Index de couleur 0–3 → numéro de carte du roi */
export function kingCardForSuit(suitIndex: number): CardNumber {
  return (suitIndex * 14 + 14) as CardNumber;
}

/** Index de couleur 0–3 → numéro de carte de la dame */
export function queenCardForSuit(suitIndex: number): CardNumber {
  return (suitIndex * 14 + 13) as CardNumber;
}

export function hasAllKingsInHand(hand: CardNumber[]): boolean {
  return KING_CARDS.every(k => hand.includes(k));
}

/** Valeur appelee envoyée au serveur Java */
export function encodeKingCallAppelee(suitIndex: number): number {
  return suitIndex;
}

export function encodeQueenCallAppelee(suitIndex: number): number {
  return 128 + suitIndex;
}

/**
 * Décode un message appel (legacy ou Neo) vers le numéro de carte appelée.
 */
export function resolveCalledCard(data: AppelData): CardNumber {
  const raw = Number(data.couleur);
  const appelDame =
    data.appelDame === 'true' ||
    data.appelDame === '1' ||
    (data.appelDame as unknown) === true;

  if (raw >= 128) {
    const suit = raw - 128;
    return queenCardForSuit(suit);
  }

  // Neo peut envoyer le numéro de carte directement
  if (raw >= 13 && raw <= 56 && raw % 14 >= 13) {
    return raw as CardNumber;
  }

  if (raw >= 0 && raw <= 3) {
    return appelDame ? queenCardForSuit(raw) : kingCardForSuit(raw);
  }

  return kingCardForSuit(0);
}
